<template>
    <div class="layout-topbar">
        <div class="layout-topbar-logo-container">
            <button v-if="showSidebar" class="layout-menu-button layout-topbar-action" @click="toggleMenu">
                <i class="pi pi-bars"></i>
            </button>
            <router-link to="#" class="layout-topbar-logo">
                <img src="/logo.svg" alt="sakai" />
                <span>Portal</span>
            </router-link>
        </div>

        <div class="layout-topbar-actions">

            <div class="layout-topbar-nav hidden lg:flex gap-10 items-center">
                <div class="relative group">
                    <div class="topbar-item flex items-center gap-1 font-medium cursor-pointer"
                        :style="openCompany ? { color: 'var(--ghm-primary)' } : {}" @mouseenter="openCompany = true"
                        @mouseleave="openCompany = false">
                        {{ $t('topBar.company') }} <i class="pi pi-chevron-down"></i>
                    </div>
                    <div v-show="openCompany" class="hover-menu absolute bg-white shadow-md mt-0  w-40 z-50"
                        @mouseenter="openCompany = true" @mouseleave="openCompany = false">
                        <a href="https://www.ghm.de/de/unternehmen/ueber-uns/" class="block px-4 py-2 hover:bg-gray-200"
                            target="_blank">{{ $t('topBar.aboutus') }}</a>
                        <a href="https://www.ghm.de/de/impressum/" target="_blank"
                            class="block px-4 py-2 hover:bg-gray-200">{{ $t('topBar.imprint') }}</a>
                        <a href="https://www.ghm.de/de/datenschutz/" target="_blank"
                            class="block px-4 py-2 hover:bg-gray-200">{{ $t('topBar.privacy') }}</a>
                    </div>
                </div>
                <div class="relative group">
                    <div class="topbar-item flex items-center gap-1 font-medium cursor-pointer"
                        :style="openLanguage ? { color: 'var(--ghm-primary)' } : {}" @mouseenter="openLanguage = true"
                        @mouseleave="openLanguage = false">
                        {{ $t('global.language') }} <i class="pi pi-chevron-down"></i>
                    </div>
                    <div v-show="openLanguage" class="hover-menu absolute bg-white shadow-md mt-0 w-40 z-50"
                        @mouseenter="openLanguage = true" @mouseleave="openLanguage = false">
                        <div :onclick="() => { setLocale('de') }"
                            class="flex items-center gap-2 px-4 py-2 hover:bg-gray-200 cursor-pointer select-none"
                            :class="{ 'font-semibold text-[var(--ghm-primary)]': locale === 'de' }">
                            <img :src="flagDe" alt="DE" class="w-5 h-4" />
                            <span>{{ $t('languages.german') }}</span>
                        </div>

                        <div :onclick="() => { setLocale('en') }"
                            class="flex items-center gap-2 px-4 py-2 hover:bg-gray-200 cursor-pointer select-none"
                            :class="{ 'font-semibold text-[var(--ghm-primary)]': locale === 'en' }">
                            <img :src="flagEn" alt="EN" class="w-5 h-4" />
                            <span>{{ $t('languages.english') }}</span>
                        </div>
                    </div>
                </div>
                <div class="relative group">
                    <LoginButton />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import LogoutButton from '@/components/mics/LogoutButton.vue';
import { useLayout } from '@/layout/composables/layout';
import { useAuthStore } from "@/stores/auth.store";
import { Button } from 'primevue';
import { onMounted, ref } from 'vue';
import { setLocale } from './../i18n.js'
import flagDe from '@/assets/flags/de.svg';
import flagEn from '@/assets/flags/en.svg';
import { useI18n } from 'vue-i18n';
import LoginButton from '@/components/mics/LoginButton.vue';

const op = ref();
const { toggleMenu, toggleDarkMode, isDarkTheme } = useLayout();

const authStore = useAuthStore();
const props = defineProps({
    showSidebar: {
        type: Boolean,
        required: true
    }
});

onMounted(() => {
    console.log("User:", authStore.user)
});

const openLanguage = ref(false);
const openSupport = ref(false);
const openCompany = ref(false);
const { locale } = useI18n();

function logout() {
    localStorage.clear()
    let keycloakLogoutUrl = '/auth/realms/ghm/protocol/openid-connect/logout?client_id=portal&post_logout_redirect_uri=' + encodeURIComponent(window.location.origin + '/');
    if (window.location.origin.includes('localhost')) {
        keycloakLogoutUrl = 'http://localhost:8080' + keycloakLogoutUrl.replace('ghm', 'master');
    }
    window.location.href = keycloakLogoutUrl;
}
</script>

<style scoped>
.layout-topbar {
    border-bottom: 2px solid var(--ghm-primary);
}

.logout-button {
    background-color: transparent;
    border: 1px solid var(--ghm-primary);
    color: var(--ghm-primary);
}

.logout-button:active {
    background-color: var(--ghm-secondary) !important;
    border: 1px solid var(--ghm-secondary) !important;
}

.logout-button:focus-visible {
    outline: none;
}

.topbar-item:hover {
    color: var(--ghm-primary);
}

.hover-menu {
    border-top: 2px solid var(--ghm-primary);
}
</style>